import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LightningModalTypes } from '../../../../core/classes/modal-types.enum';

@Component({
  templateUrl: './modal-fast-track-images.component.html',
  styleUrls: ['./modal-fast-track-images.component.scss'],
  standalone: false
})
export class ModalFastTrackImagesComponent implements OnInit {
  photos: string[] = null;
  selected: string;
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.selected = this.photos[0];
  }
}

LightningModalTypes.ModalFastTrackImagesComponent.component = ModalFastTrackImagesComponent;
